import NavBar from "../landingPage/header/navbar";
import React, {useEffect, useState} from "react";
import Footer from "../landingPage/footer";
import TextConstants from "../../TextConstants";
import MetaTagContents from "../../MetaTagContents";
import { Helmet } from "react-helmet";
import "./walmart.scss";

const Walmart = () => {
  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{MetaTagContents.INTEGRATIONS.title}</title>
        <link rel="canonical" href="https://all3d.ai/integrations" />
      </Helmet>
      <React.Fragment>
        <NavBar />
        <div className="container-fluid walmart-integration-container">
          <div className="integrations">
            <WebVersion />
            <MobileVersion />
          </div>
        </div>
        <Footer />
      </React.Fragment>
    </div>
  );
};

const { title, detailsText, buttonTitleText, buttonText } =
  TextConstants.WALMART_INTEGRATION;

const WebVersion = (props) => {

  const [source,setSource] = useState(null)

  useEffect(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source')
    if (source) {
      setSource(source)
    }
  },[])

  const handleCardClick = () => {
    if (source) {
      window.location.href = `/contact-us?contact-footer=true&source=${source}`
    } else {
      window.location.href = '/contact-us?contact-footer=true'
    }
  }

  return (
    <div className="d-none d-lg-block">
      <div
        className="col-lg-12 col-12"
        id="textSection"
        style={{ margin: "auto", marginTop: 20, padding: 0 }}
      >
        <h1 className="font lora f-32 w-400 ws-6 black-2b justify-in-center">
          {title}
        </h1>
      </div>
      <div className="justify-in-center">
                  <div className="walmart-integration-details">
            <img
              className="ml-12 walmart-integration-model"
              src="/walmart-logo.svg"
              alt="#"
            />
          <span className="font graphik-regular f-20 w-400 black-2b mt-16 ml-12">
            {detailsText}
          </span>
        </div>
      </div>
      <div className="walmart-integration-button">
        <p className="font graphik-regular f-16 w-400 black-2b mt-16">
          {buttonTitleText}
        </p>
        <button
          onClick={handleCardClick}
          type="button"
          className="btn connect-btn font graphik-regular mt-16 f-16 w-500 white"
        >
          {buttonText}
          <img className="ml-12" src="/landingPage/right-arrow.png" alt="#" />
        </button>
      </div>
    </div>
  );
};

const MobileVersion = (props) => {

  const [source,setSource] = useState(null)

  useEffect(()=> {
    const urlParams = new URLSearchParams(window.location.search);
    const source = urlParams.get('source')
    if (source) {
      setSource(source)
    }
  },[])

  const handleCardClick = () => {
    if (source) {
      window.location.href = `/contact-us?source=${source}`
    } else {
      window.location.href = '/contact-us'
    }
  }
  
  return (
    <div className="d-lg-none">
      <div
        className="col-lg-12 col-12"
        id="textSection"
        style={{ margin: "auto", padding: 0 }}
      >
        <h1 className="font lora f-32 w-400 ws-6 black-2b justify-in-center text-center">
          {title}
        </h1>
      </div>
      <div className="justify-in-center">
        <div className="walmart-integration-details--mobile">
          <img
            className="ml-12"
            style={{ width: "100%" }}
            src="/walmart-logo.svg"
            alt="#"
          />
          <p className="font graphik-regular f-20 w-400 black-2b mt-16 text-center">
            {detailsText}
          </p>
        </div>
      </div>
      <div className="walmart-integration-button">
        <p className="font graphik-regular f-16 w-400 black-2b mt-16 text-center">
          {buttonTitleText}
        </p>
        <button
          onClick={handleCardClick}
          type="button"
          className="btn connect-btn font graphik-regular mt-16 f-16 w-500 white"
        >
          {buttonText}
          <img className="ml-12" src="/landingPage/right-arrow.png" alt="#" />
        </button>
      </div>
    </div>
  );
};

export default Walmart;
